import script from "./NavbarSimakad.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarSimakad.vue?vue&type=script&setup=true&lang=js"

import "./NavbarSimakad.vue?vue&type=style&index=0&id=334da0c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334da0c6"]])

export default __exports__